import { useState } from 'react';
import PropTypes from 'prop-types';
import SaveButtonComponent from '../utilsComponents/SaveButtonComponent';
import { RemoveRowButtonComponent } from '../utilsComponents/RemoveRowButtonComponent';

const TitleForbiddenChars = ({
  titleForbiddenChars,
  setTitleForbiddenChars,
  onSaveSettings,
  isValidated,
  isValidatedKg,
  loading,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [messageError, setMessageError] = useState('');

  const normalizedList = Array.isArray(titleForbiddenChars)
    ? titleForbiddenChars
    : [];

  const handleAdd = () => {
    const value = inputValue.trim();
    setMessageError('');

    if (!value) {
      setMessageError('Ingresá un carácter o cadena prohibida');
      return;
    }

    if (normalizedList.includes(value)) {
      setMessageError('Ese valor ya está en la lista');
      return;
    }

    setTitleForbiddenChars([...normalizedList, value]);
    setInputValue('');
  };

  const handleRemove = (_position, item) => {
    setTitleForbiddenChars(
      normalizedList.filter((char) => char !== item)
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleAdd();
    }
  };

  return (
    <div className='flex flex-col gap-4'>
      <p className='text-sm text-gray-600'>
        Si el título del catálogo de Mercado Libre contiene alguno de estos
        caracteres o cadenas (coincidencia parcial), el artículo aparecerá en la
        pestaña &quot;Carácter prohibido en título&quot; al cargar ASINs. Ejemplo:
        símbolos como <span className='font-mono'>$</span> que no conviene
        agregar a la lista negra de marcas.
      </p>

      <div className='flex flex-col gap-2 sm:flex-row sm:items-end'>
        <div className='flex-1'>
          <label
            htmlFor='title-forbidden-char-input'
            className='block text-sm font-medium text-gray-700'
          >
            Carácter o cadena
          </label>
          <input
            id='title-forbidden-char-input'
            type='text'
            value={inputValue}
            onChange={(e) => {
              setMessageError('');
              setInputValue(e.target.value);
            }}
            onKeyDown={handleKeyDown}
            placeholder='Ej: $'
            className='mt-1 block w-full rounded-lg border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-300 sm:text-sm pl-3'
          />
        </div>
        <button
          type='button'
          onClick={handleAdd}
          disabled={!inputValue.trim()}
          className='shrink-0 rounded-lg border border-primary-100 bg-primary-100 px-4 py-2 text-sm font-semibold text-primary-700 transition hover:border-primary-500 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-200 disabled:text-gray-400'
        >
          Agregar
        </button>
      </div>

      {messageError && (
        <p className='text-sm text-red-600' role='alert'>
          {messageError}
        </p>
      )}

      {normalizedList.length > 0 ? (
        <ul className='flex flex-wrap gap-2'>
          {normalizedList.map((char) => (
            <li
              key={char}
              className='inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-3 py-1 text-sm font-medium text-gray-800 shadow-sm'
            >
              <span className='font-mono'>{char}</span>
              <RemoveRowButtonComponent
                position={char}
                name={char}
                onRemoveRow={handleRemove}
              />
            </li>
          ))}
        </ul>
      ) : (
        <p className='text-sm text-gray-500'>
          No hay caracteres prohibidos configurados.
        </p>
      )}

      <div className='w-full flex justify-end pt-1'>
        <SaveButtonComponent
          onSaveSettings={onSaveSettings}
          isValidated={isValidated}
          isValidatedKg={isValidatedKg}
          loading={loading}
        />
      </div>
    </div>
  );
};

TitleForbiddenChars.propTypes = {
  titleForbiddenChars: PropTypes.arrayOf(PropTypes.string),
  setTitleForbiddenChars: PropTypes.func.isRequired,
  onSaveSettings: PropTypes.func.isRequired,
  isValidated: PropTypes.bool,
  isValidatedKg: PropTypes.bool,
  loading: PropTypes.bool,
};

export default TitleForbiddenChars;
